module.exports = __webpack_public_path__ + "static/media/empty-task-icon.71acc1ca.svg";